export default "__VITE_ASSET__qX3tShcQ__"